import { useTranslation } from 'react-i18next';
import { entityImagesDetailed, type ModerationEntity } from '@/entities/moderation';
import { PreviewableImage } from './image-preview';

export function HeroImage({
  entity,
  placeholder = false,
}: {
  entity: ModerationEntity;
  /** Renders a «no photo» tile when absent, so compared columns keep their rows. */
  placeholder?: boolean;
}) {
  const { t } = useTranslation('moderation');
  const first = entityImagesDetailed(entity)[0];
  if (!first) {
    // Entities without photos (categories, promotions) render no hero block.
    if (!placeholder) return null;
    return (
      <div
        data-testid="hero-placeholder"
        className="flex h-[140px] w-full items-center justify-center rounded-[16px] bg-muted text-sm text-muted-foreground"
      >
        {t('detail.noPhoto', 'Нет фото')}
      </div>
    );
  }
  return (
    <PreviewableImage
      src={first.url}
      loading="eager"
      className="h-[140px] w-full rounded-[16px] object-cover"
    />
  );
}
